import { IAppState } from 'shared/common/state';

export function selectCallbackWidgetOpeningTrigger(state: IAppState) {
  return state.newbuildingBrokerCallbackWidget.openingTrigger;
}
